<template>
    <div class="main">
        <c-panel title="REMANEJAMENTO DE ALUNOS" titleIcon="fas fa-exchange-alt">

            <!--
                BLOCO E — item 56: remanejamento entre turmas com motivo obrigatório
                e histórico por matrícula.

                Nenhum id é digitado: escola → período → turma de origem → aluno, e a
                turma de destino sai da mesma escola/período. A capacidade da turma de
                destino é validada pelo backend (item 94) — a tela apenas oferece o
                "forçar" a quem o backend aceita.
            -->
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Remanejar troca a turma do aluno dentro da MESMA escola e do MESMO período letivo."
                description="Para mudança de escola use transferência. Todo remanejamento fica registrado no histórico da matrícula."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="escolaId" filterable style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Turma de origem" class="u-mb-0">
                            <el-select v-model="turmaOrigemId" filterable style="width: 100%;" @change="carregarAlunos"
                                :disabled="!escolaId || !periodoId" no-data-text="Nenhuma turma nesta escola/período">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="turmaOrigemId" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Aluno</th>
                            <th style="width: 160px;">Matrícula</th>
                            <th style="width: 230px;" class="u-text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in alunos" :key="m.id">
                            <td>{{ m.nome_aluno }}</td>
                            <td>{{ m.num_matricula || '—' }}</td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" @click="abrirRemanejar(m)" size="mini" plain>REMANEJAR</el-button>
                                <el-button class="u-ml-10" @click="abrirHistorico(m)" size="mini" type="text">HISTÓRICO</el-button>
                            </td>
                        </tr>
                        <tr v-if="alunos.length === 0"><td colspan="3" class="u-text-center">Nenhum aluno enturmado nesta turma.</td></tr>
                    </tbody>
                </table>
            </div>

            <!-- ==================== REMANEJAR ==================== -->
            <el-dialog title="Remanejar aluno" :visible.sync="dialogo" width="560px">
                <el-alert v-if="atual" type="info" :closable="false" class="u-mb-15"
                    :title="atual.nome_aluno"
                    :description="'Turma atual: ' + nomeTurma(turmaOrigemId)"></el-alert>

                <el-form label-position="top">
                    <el-form-item label="Turma de destino">
                        <el-select v-model="form.turma_destino_id" filterable style="width: 100%;"
                            no-data-text="Nenhuma outra turma nesta escola/período">
                            <el-option v-for="t in turmasDestino" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="Motivo">
                                <el-select v-model="form.motivo_id" style="width: 100%;" @change="motivoMudou">
                                    <el-option v-for="m in motivos" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Data">
                                <el-date-picker v-model="form.data_remanejamento" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item :label="exigeJustificativa ? 'Justificativa (obrigatória para este motivo)' : 'Justificativa'">
                        <el-input v-model="form.justificativa" type="textarea" :rows="3"></el-input>
                    </el-form-item>

                    <el-alert v-if="erro" type="warning" :closable="false" :title="erro" class="u-mb-10"></el-alert>

                    <el-checkbox v-if="erro && podeForcar" v-model="form.forcar">
                        Remanejar mesmo assim (turma de destino sem vaga)
                    </el-checkbox>
                </el-form>

                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :disabled="!form.turma_destino_id || !form.motivo_id" @click="remanejar">REMANEJAR</el-button>
                </span>
            </el-dialog>

            <!-- ==================== HISTÓRICO ==================== -->
            <el-dialog title="Histórico de remanejamentos" :visible.sync="dialogoHist" width="700px">
                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 110px;">Data</th>
                                <th>De</th>
                                <th>Para</th>
                                <th>Motivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="h in historico" :key="h.id">
                                <td>{{ dataBr(h.data_remanejamento) }}</td>
                                <td>{{ h.turma_origem ? h.turma_origem.nome : '—' }}</td>
                                <td>{{ h.turma_destino ? h.turma_destino.nome : '—' }}</td>
                                <td>
                                    {{ h.motivo ? h.motivo.nome : '—' }}
                                    <div v-if="h.justificativa"><small class="u-text-muted">{{ h.justificativa }}</small></div>
                                </td>
                            </tr>
                            <tr v-if="historico.length === 0"><td colspan="4" class="u-text-center">Nenhum remanejamento nesta matrícula.</td></tr>
                        </tbody>
                    </table>
                </div>
                <span slot="footer"><el-button @click="dialogoHist = false">FECHAR</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 56: remanejamento com motivo e histórico. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        escolaId: null, periodoId: null, turmaOrigemId: null,
        instituicoes: [], turmas: [], alunos: [], motivos: [],
        dialogo: false, atual: null, erro: null,
        form: { matricula_id: null, turma_destino_id: null, motivo_id: null, justificativa: '', data_remanejamento: '', forcar: false },
        dialogoHist: false, historico: []
    }),
    computed: {
        /** Esconder o botão não é segurança: o backend continua sendo a autoridade. */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        /** Só perfis de rede podem sobrepor a capacidade (mesma regra do backend). */
        podeForcar () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) },
        turmasDestino () { return this.turmas.filter(t => t.id !== this.turmaOrigemId) },
        exigeJustificativa () {
            const m = this.motivos.find(x => x.id === this.form.motivo_id)
            return !!(m && m.exige_justificativa)
        }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.escolaId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregarTurmas())

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/remanejamento/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.motivos = (r.data && r.data.motivos) ? r.data.motivos : [] })
         .catch(e => this.$store.commit('throwException', e))
    },
    methods: {
        carregarTurmas () {
            this.turmas = []; this.alunos = []; this.turmaOrigemId = null
            if (!this.escolaId || !this.periodoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.escolaId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() })
             .catch(e => this.$store.commit('throwException', e))
        },
        carregarAlunos () {
            this.alunos = []
            if (!this.turmaOrigemId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.turmaOrigemId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alunos = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        nomeTurma (id) {
            const t = this.turmas.find(x => x.id === id)
            return t ? t.nome : '—'
        },
        motivoMudou () { this.erro = null },
        abrirRemanejar (m) {
            this.atual = m
            this.erro = null
            this.form = { matricula_id: m.id, turma_destino_id: null, motivo_id: null,
                justificativa: '', data_remanejamento: '', forcar: false }
            this.dialogo = true
        },
        remanejar () {
            this.erro = null
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/remanejamento/store`,
                this.form, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { this.erro = r.data.erro; return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogo = false
                this.carregarAlunos()
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirHistorico (m) {
            this.historico = []
            this.dialogoHist = true
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/remanejamento/getByMatricula/${m.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.historico = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        }
    }
}
</script>
